import { render, staticRenderFns } from "./tabs_whole.vue?vue&type=template&id=956daa1e&scoped=true&"
import script from "./tabs_whole.vue?vue&type=script&lang=js&"
export * from "./tabs_whole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956daa1e",
  null
  
)

export default component.exports